import { generateUtilityClasses } from '@mui/material';

const COMPONENT_NAME = 'PaiSuggestionList';

export const suggestionListClasses = {
  ...generateUtilityClasses(COMPONENT_NAME, ['root']),
};
